import React from 'react'

import { Route, Routes, useLocation } from 'react-router-dom'

import { wrapSuspenseScreen } from '@newComponents/SuspenseWrapper'
import { lazy as loadable } from '@loadable/component'

const EventEditNavigator = wrapSuspenseScreen(
  loadable(() => import('./EventEditNavigator'))
)

const EventScreenNew = wrapSuspenseScreen(
  loadable(() => import('../screens/EventScreenNew/EventScreenNew'))
)

const EventAttendScreen = wrapSuspenseScreen(
  loadable(() => import('../screens/EventAttendScreen/EventAttendScreen'))
)

const EventTicketPaymentScreen = wrapSuspenseScreen(
  loadable(
    () => import('../screens/EventTicketPaymentScreen/EventTicketPaymentScreen')
  )
)

const EventTicketPaymentConfirmScreen = wrapSuspenseScreen(
  loadable(
    () =>
      import(
        '../screens/EventTicketPaymentConfirmScreen/EventTicketPaymentConfirmScreen'
      )
  )
)

const EventTicketEditScreen = wrapSuspenseScreen(
  loadable(
    () => import('../screens/EventTicketEditScreen/EventTicketEditScreen')
  )
)

const ClaimTicketScreen = wrapSuspenseScreen(
  loadable(() => import('../screens/ClaimTicketScreen/ClaimTicketScreen'))
)

const ClaimEventHostScreen = wrapSuspenseScreen(
  loadable(() => import('../screens/ClaimEventHostScreen/ClaimEventHostScreen'))
)

export const EventNavigator = () => {
  const location = useLocation()

  const locationState = location.state as { backgroundLocation?: Location }

  return (
    <Routes location={locationState?.backgroundLocation || location}>
      <Route index element={<EventScreenNew />} />

      <Route path='attend' element={<EventAttendScreen />} />
      <Route path='payment' element={<EventAttendScreen />} />
      <Route
        path='payment/confirm'
        element={<EventTicketPaymentConfirmScreen />}
      />
      <Route path='tickets' element={<EventTicketEditScreen />} />
      <Route path='claim-ticket' element={<ClaimTicketScreen />} />
      <Route path='claim-host' element={<ClaimEventHostScreen />} />
      <Route path='settings/*' element={<EventEditNavigator />} />
    </Routes>
  )
}

export default EventNavigator
